module.exports = __webpack_public_path__ + "img/coaching_tools.a2ef088d.jpg";